import { useFormContext } from '@calendly/form'
import { useCallback, useEffect, useRef } from 'react'

const useAutoSave = ({ formContentRef }) => {
  const interactionTimeout = useRef(null)
  const {
    submitForm,
    dirty,
    values
  } = useFormContext()

  const handleSave = useCallback(() => {
    if (interactionTimeout.current) {
      clearTimeout(interactionTimeout.current)
    }

    interactionTimeout.current = setTimeout(() => {
      if (dirty) {
        submitForm()
      }
    }, 1000)
  }, [dirty, submitForm])

  useEffect(() => {
    const formContent = formContentRef.current

    if (formContent) {
      formContent.addEventListener('click', handleSave)
      formContent.addEventListener('keydown', handleSave)
    }

    return () => {
      if (formContent) {
        formContent.removeEventListener('click', handleSave)
        formContent.removeEventListener('keydown', handleSave)
      }
    }
  }, [formContentRef, handleSave])

  useEffect(() => {
    if (dirty) {
      handleSave()
    }
  }, [dirty, handleSave, values])

  return null
}

export const AutoSave = ({ formContentRef }) => {
  useAutoSave({ formContentRef })

  return null
}
